import { Avatar, Card, Flex, theme, Typography } from 'antd'
import { useTokens } from '@entities/token'
import { HeartOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import React from 'react'
import { tableData } from '@pages/stock-buy-advertising/ui/constants'
import useMobileView from '@shared/hooks/isMobile'

const { Text } = Typography

const SVGBasket = () => (
    <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="32" height="21" rx="4.5" stroke="#63C930" />
        <path
            d="M12.3555 10.6611V11.8506H5.5332V10.6611H12.3555ZM9.58008 7.75586V15.002H8.31543V7.75586H9.58008Z"
            fill="#63C930"
        />
        <path
            d="M19.625 7.125H19.5C19.5688 7.125 19.625 7.06875 19.625 7V7.125H24.375V7C24.375 7.06875 24.4313 7.125 24.5 7.125H24.375V8.25H25.5V7C25.5 6.44844 25.0516 6 24.5 6H19.5C18.9484 6 18.5 6.44844 18.5 7V8.25H19.625V7.125ZM27.5 8.25H16.5C16.2234 8.25 16 8.47344 16 8.75V9.25C16 9.31875 16.0563 9.375 16.125 9.375H17.0688L17.4547 17.5469C17.4797 18.0797 17.9203 18.5 18.4531 18.5H25.5469C26.0813 18.5 26.5203 18.0813 26.5453 17.5469L26.9313 9.375H27.875C27.9438 9.375 28 9.31875 28 9.25V8.75C28 8.47344 27.7766 8.25 27.5 8.25ZM25.4266 17.375H18.5734L18.1953 9.375H25.8047L25.4266 17.375Z"
            fill="#63C930"
        />
    </svg>
)

export const CardView = () => {
    const isMobile = useMobileView()

    const {
        token: { colorPrimary }
    } = theme.useToken()
    return (
        <div style={{ marginTop: isMobile ? 8 : 38 }}>
            <Flex gap={isMobile ? 17 : 45} justify={'center'} wrap={'wrap'}>
                {[...tableData, ...tableData].map((item, index) => {
                    console.log(1)
                    return (
                        <Card
                            size="small"
                            key={index}
                            style={{ backgroundColor: '#ffffff', width: isMobile ? '100%' : 'auto' }}
                        >
                            <Flex gap={20} justify={'space-between'}>
                                <div style={{ position: 'relative' }}>
                                    <Avatar size={80} icon={<UserOutlined />} />
                                    <HeartOutlined
                                        style={{ color: colorPrimary, position: 'absolute', bottom: 5, right: 0 }}
                                    />
                                </div>
                                <Flex gap={'middle'}>
                                    <Flex justify={'space-between'} vertical>
                                        <Flex vertical>
                                            <Text strong>{item.name}</Text>
                                            <Text style={{ color: colorPrimary }}>{item.username}</Text>
                                        </Flex>
                                        <Flex gap={3}>
                                            <TeamOutlined style={{ color: colorPrimary }} />
                                            <Text style={{ color: colorPrimary }}>{item.membersCount}</Text>
                                        </Flex>
                                    </Flex>
                                    <Flex vertical>
                                        <Flex
                                            style={{
                                                borderRadius: '8px',
                                                border: '2px solid #7C9BAD',
                                                width: 120,
                                                marginBottom: 10
                                            }}
                                            vertical
                                        >
                                            <Text style={{ textAlign: 'center', color: colorPrimary }}>
                                                {item.cost}
                                            </Text>
                                            <div style={{ width: '100%', border: '1px solid #7C9BAD' }} />
                                            <Text style={{ textAlign: 'center', color: colorPrimary }}>
                                                {item.type}
                                            </Text>
                                        </Flex>
                                        <Flex gap={23} align={'center'} justify={'end'}>
                                            <Flex gap={'small'}>
                                                <TeamOutlined style={{ color: colorPrimary }} />
                                                <Text style={{ color: colorPrimary }}>{item.membersCount}</Text>
                                            </Flex>
                                            <SVGBasket />
                                        </Flex>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Card>
                    )
                })}
            </Flex>
        </div>
    )
}
